import { useContext, useMemo } from 'react';
import type { ComponentEnhancer } from 'recompose';
import { withSnowplow } from '@mindtickle/ui-shell-core/Snowplow';
import { LocalAuthContext } from '~/components/Auth';
import getGlobalContextData from '~/components/Snowplow/globalContext';

const withSnowPlow = <P extends {}>({
  collectorUrl,
  namespace,
  isGlobalContextNeeded = true,
}: {
  collectorUrl: string;
  namespace: string;
  isGlobalContextNeeded?: boolean;
}) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const auth = useContext(LocalAuthContext);
    const globalContext: any = useMemo(
      () => (isGlobalContextNeeded ? getGlobalContextData(auth?.user, auth?.company) : []),
      [auth?.user, auth?.company]
    );

    const WrappedComponent = useMemo(
      () =>
        withSnowplow<P>({
          collectorUrl,
          namespace,
          globalContexts: globalContext,
        })(Component),
      [globalContext]
    );

    return <WrappedComponent {...props} />;
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withSnowPlow;
